import { NetworkStatusButton } from '@/components/network-status/NetworkStatusButton'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { CustomizeDialog } from './CustomizeDialog'
import { FooterItemLink } from './FooterItemLink'
import { HelpMenu } from './HelpMenu'
import { MoreMenu } from './MoreMenu'
import { arrangeFooterItems } from './footerBarModel'
import { useFooterBarPrefs } from './footerBarPrefs'
import { useShortcutsDialogStore } from './shortcutsDialogStore'
import { useFooterItems } from './useFooterItems'

/** Help and network status on the left, then the pinned items and the arrows that open the full menu. */
export function SidebarFooterBar({ disabled }: { disabled: boolean }) {
	const items = useFooterItems()
	const prefs = useFooterBarPrefs()
	const { bar, shown } = arrangeFooterItems(items, prefs)
	const setShortcutsOpen = useShortcutsDialogStore(s => s.setOpen)
	const [customizeOpen, setCustomizeOpen] = useState(false)

	return (
		<div className='flex gap-1 px-2 pb-2'>
			<HelpMenu onOpenShortcuts={() => setShortcutsOpen(true)} />
			<NetworkStatusButton />
			<div
				className={cn(
					'flex min-w-0 flex-1 items-center justify-end gap-0.5 rounded-lg bg-sidebar-accent/50 p-1',
					disabled && 'pointer-events-none opacity-40 select-none',
				)}
				data-testid='sidebar-bar'>
				{bar.map(item => (
					<Tooltip key={item.id}>
						<TooltipTrigger asChild>
							<FooterItemLink
								item={item}
								aria-label={item.title}
								data-testid={`sidebar-bar-pin-${item.id}`}
								className='flex h-7 min-w-0 flex-1 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-sidebar-accent hover:text-foreground'>
								<item.icon className='size-(--icon-standalone)' aria-hidden />
							</FooterItemLink>
						</TooltipTrigger>
						<TooltipContent side='top'>{item.title}</TooltipContent>
					</Tooltip>
				))}
				{bar.length > 0 && <span className='mx-0.5 h-4 w-px shrink-0 bg-border' aria-hidden />}
				<MoreMenu items={shown} onCustomize={() => setCustomizeOpen(true)} />
			</div>
			<CustomizeDialog open={customizeOpen} onOpenChange={setCustomizeOpen} items={items} />
		</div>
	)
}
